<div class="flex flex-row gap-2">
  <button pButton type="button" [routerLink]="routes.DASHBOARD" label="DASHBOARD"></button>
  <button pButton type="button" (click)="aim_menu.toggle($event)" icon="pi pi-bars" label="AIM"></button>
  <button pButton type="button" (click)="site_menu.toggle($event)" icon="pi pi-bars" label="SITE"></button>
</div>
<p-menu #aim_menu [model]="aimMenuItems" [popup]="true"></p-menu>
<p-menu #site_menu [model]="siteMenuItems" [popup]="true"></p-menu>
